module.exports = __webpack_public_path__ + "static/img/16060C_1_2_C_20210407_LC.fa1a57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16060C_1_2_C_20210407_LC.png
// module id = rLcv
// module chunks = 0